// @flow
import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import MainTemplate from 'components/templates/MainTemplate'
import {
  ReputationListHeader,
  HostSummary,
  ReputationListItem,
} from 'components/shared'
import Breadcrumbs from 'components/shared/Breadcrumbs'
import { viewerFragment, companyManagedFragment } from 'common/fragments'
import { ownerFragment, searchMasterFragment } from 'common/fragments/www'
import Path from 'routes/path'

import TopicListPage from 'components/pages/TopicListPage'
import PromotionListPage from 'components/pages/PromotionListPage'
import type { Topic } from 'types/stay/topic'

import { imagePath } from 'frontend_core/dist/helpers/image'

type PropTypes = {
  data: {
    topics: {
      results: Array<Topic>,
    },
    promotions: {
      results: Array<Promotion>,
    },
  },
  location: {
    pathname: string,
  },
  config: {
    ORIGIN: string,
  },
}

const TopicListContainer = (props: PropTypes) => {
  const { data, location, config } = props
  const { topics, promotions } = data
  return (
    <MainTemplate
      title={i18n.t('server.www.topicList.title')}
      description={i18n.t('server.www.topicList.description')}
      image={imagePath('www/common/ogimage.png')}
      linkCanonical={`${config.ORIGIN}${location.pathname}`}
      {...props}
    >
      <Breadcrumbs breadcrumbs={topics.breadcrumbs} />
      <div className="site-main">
        <div className="page__even page__padding campaign-list-page__list">
          <TopicListPage
            topicItemCardPropsList={topics.results.map((topic: Topic) => ({
              id: topic.id,
              uid: topic.uid,
              title: topic.title,
              image: topic.image,
              themeColor: topic.themeColor,
              link: Path.topic(`${topic.uid}`),
            }))}
          />
        </div>
        <div className="page__odd page__padding campaign-list-page__list">
          <PromotionListPage
            promotionItemCardPropsList={promotions.results.map(
              (promotion: Promotion) => ({
                id: promotion.id,
                title: promotion.title,
                image: promotion.image,
                backgroundColor: promotion.backgroundColor,
                coupon: promotion.coupon,
                pointCode: promotion.pointCode,
              }),
            )}
          />
        </div>
      </div>
    </MainTemplate>
  )
}

const topicListQuery = gql`
{
  ${searchMasterFragment}
  topics {
    breadcrumbs {
      title
      path
    }
    results {
      id
      uid
      title
      image
      themeColor
    }
  }
  promotions(page: 1) {
    results {
      backgroundColor
      backgroundImage
      id
      linkColor
      textColor
      title
      image
      coupon {
        validAt
        expiresAt
      }
      pointCode {
        validAt
        expiresAt
      }
    }
  }
  viewer {
    ${viewerFragment}
  }
}
`

const withData = graphql(topicListQuery)(TopicListContainer)
function mapStateToProps(state: Object) {
  return state
}

export default withRouter(connect(mapStateToProps)(withData))



// WEBPACK FOOTER //
// ./src/containers/pages/TopicListPage.jsx